<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 5.75C4 4.7835 4.7835 4 5.75 4H10.25C11.2165 4 12 4.7835 12 5.75V10.25C12 11.2165 11.2165 12 10.25 12H5.75C4.7835 12 4 11.2165 4 10.25V5.75ZM5.75 5.5C5.61193 5.5 5.5 5.61193 5.5 5.75V10.25C5.5 10.3881 5.61193 10.5 5.75 10.5H10.25C10.3881 10.5 10.5 10.3881 10.5 10.25V5.75C10.5 5.61193 10.3881 5.5 10.25 5.5H5.75Z"
    fill="currentColor"
  />
</svg>
